import { Action } from 'grids/action/action';
import { GridContainer } from 'libs/ui';

export const ActionWrapper = (props) => {
  return (
    <GridContainer>
      <Action {...props} />
    </GridContainer>
  );
};
